// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IqF78Spr_N4NDgCip1N2{display:flex;flex-direction:row;align-items:center;justify-content:center}`, "",{"version":3,"sources":["webpack://./src/components/Banner.scss"],"names":[],"mappings":"AAAA,sBACI,YAAA,CACA,kBAAA,CACA,kBAAA,CACA,sBAAA","sourcesContent":[".banner {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var banner = `IqF78Spr_N4NDgCip1N2`;
export default ___CSS_LOADER_EXPORT___;
